import React from 'react';
import { StyledMarquee } from './StyledMarquee';

const Marquee = ({ }) => {
  return (
    <React.Fragment>
      {
       
          <StyledMarquee
          >
            <div className="marquee--wrap">
              <div className="marquee--slider">
                <h5 className="big--title">
                You can sell anything, anywhere. You can sell anything, anywhere.  
                </h5>
              </div>
              <div className="marquee--slider">
                <h5 className="big--title">
                You can sell anything, anywhere. You can sell anything, anywhere.  
                </h5>
              </div>
            </div>
            
          </StyledMarquee>
          
      }
    </React.Fragment>
  );
};

export default Marquee;
